module.exports = __webpack_public_path__ + "img/slider_20.dd21b04f.jpg";